import { Beneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/beneficiary";
import { Card } from "src/app/ui/models/domains/pbm/Beneficiary/card";
import { Dependent } from "src/app/ui/models/domains/pbm/Beneficiary/dependent";
import { Employee } from "src/app/ui/models/domains/pbm/Beneficiary/employee";
import { JobDescription } from "src/app/ui/models/domains/pbm/Beneficiary/job-description";
import { Gender, MaritalStatus, Person } from "src/app/ui/models/domains/pbm/Beneficiary/person";
import { BeneficiaryKey } from "src/app/ui/models/domains/pbm/Benefit/beneficiary-key";
import { parseAddress } from "../company/company-parse-functions";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";

export function parseBeneficiaryKey(payload: any): BeneficiaryKey {
  const beneficiaryKey = new BeneficiaryKey();
  if (payload) {
    beneficiaryKey.setValue(payload.Value);
  }
  return beneficiaryKey;
}

export function parseCard(payload: any): Card {
  const card = new Card();
  card.setCardNumber(payload.CardNumber);
  card.setIsBlocked(payload.IsBlocked);
  card.setIsCancelled(payload.IsCancelled);
  return card;
}

export function parseCompany(payload: any): Company[] {
  const companies = [];
  if (payload) {
    payload.map((companyItem) => {
      const company = new Company();
      company.setFiscalNumber(companyItem.FiscalNumber);
      company.setCorporateName(companyItem.CorporateName);
      companies.push(company);
    });
  }
  return companies;
}

export function parseJobDescription(payload: any): JobDescription {
  return new JobDescription(payload.Key.Value, payload.Title, payload.IsGeneric, payload.Enabled);
}

export function parseGender(payload: any): Gender {
  const personGender = new Gender();
  personGender.setGender(payload);
  return personGender;
}

export function parseMaritalStatus(payload: any): MaritalStatus {
  const personMaritalStatus = new MaritalStatus();
  personMaritalStatus.setMaritalStatus(payload);
  return personMaritalStatus;
}

export function parsePerson(payload: any, person: Person): void {
  person.setName(payload.Name);
  person.setSocialNumber(typeof payload.SocialNumber === "string" ? payload.SocialNumber : payload.SocialNumber.Value);
  person.setBirthDate(payload.BirthDate ? payload.BirthDate : "");
  person.setEmail(payload.Email);
  person.setTelephone(payload.Telephone ? payload.Telephone : "");
  person.setMobile(payload.Mobile ? payload.Mobile : "");
  person.setGender(parseGender(payload.Gender));
  person.setMaritalStatus(parseMaritalStatus(payload.MaritalStatus));
  person.setAddress(parseAddress(payload.Address));
}

export function parseEmployee(payload: any, beneficiary: Beneficiary): void {
  const employee = new Employee();
  if (payload) {
    employee.setRegistration(payload.Registration);
    employee.setAdmissionDate(payload.AdmissionDate ? payload.AdmissionDate : "");
    employee.setJobDescription(payload.JobDescription ? parseJobDescription(payload.JobDescription) : null);
  }
  beneficiary.setEmployee(employee);
}

export function parseBeneficiary(payload: any): Beneficiary {
  const beneficiary = new Beneficiary();
  payload.Active ? beneficiary.activateBeneficiary() : beneficiary.inactivateBeneficiary();
  beneficiary.setIsHolder(payload.IsHolder);
  beneficiary.setBeneficiaryKey(parseBeneficiaryKey(payload.BeneficiaryKey));
  beneficiary.setCard(parseCard(payload.Card));
  beneficiary.setNeedValidateEmail(payload.NeedValidateEmail);
  beneficiary.setEnableDelivery(payload.EnableDelivery);
  beneficiary.setLimit(payload.Limit);
  beneficiary.setLimitType(payload.LimitType)
  beneficiary.setTransactionPasswordRequired(payload.TransactionPasswordRequired);
  if(payload.ParentBeneficiaryKey){
    beneficiary.setParentBeneficiaryKey(parseBeneficiaryKey(payload.ParentBeneficiaryKey));
  }
  if(payload.Company){
    beneficiary.setCompany(parseCompany(payload.Company));
  }
  parseEmployee(payload.Employee, beneficiary);
  parsePerson(payload, beneficiary);

  if (payload.Dependents) {
    payload.Dependents.map((dependentItem) => {
      const dependent = new Dependent();
      dependentItem.Active ? dependent.activate() : dependent.deactivate();
      dependent.setBeneficiaryKey(parseBeneficiaryKey(dependentItem.BeneficiaryKey))
      dependent.setBeneficiarySocialNumber(dependentItem.BeneficiarySocialNumber);
      dependent.setCard(parseCard(dependentItem.Card));
      dependent.setNeedValidateEmail(dependentItem.NeedValidateEmail);
      dependent.setEnableDelivery(dependentItem.EnableDelivery);
      dependent.setTransactionPasswordRequired(dependentItem.TransactionPasswordRequired);
      dependent.setLimitType(payload.LimitType)
      dependent.setLimit(dependentItem.Limit)
      parsePerson(dependentItem, dependent);
      beneficiary.addDependent(dependent);
    });
  }

  return beneficiary;
}
